import { FC, useEffect, useState } from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import moment from "moment";
import { BadgeStatusText } from "components/BadgeStatus";
import { getOnePara } from "../service";
import { asyncN } from "utils/notifications";
import { useTranslation } from "react-i18next";
const { Text } = Typography;

const ParaView: FC<{ visible: boolean, setVisible: (visible: boolean) => void, id: number | null }> = ({ visible, setVisible, id }): JSX.Element => {

    const [data, setData] = useState<any>(null)
    const { t } = useTranslation();
    const [showCreated, setShowCreated] = useState<boolean>(false);

    useEffect(() => {
        if (visible) {
            (
                async () => {
                    try {
                        const response = await getOnePara(id, 'expand=createdBy,updatedBy,description&self=1')
                        setData(response)
                    } catch (error: any) {
                        setVisible(false)
                        asyncN("error", "read", error?.response?.message)
                    }
                }
            )()
        }
    }, [visible])

    return (
        <>
            {data && <Modal
                width={750}
                title={t("Para view")}
                visible={visible}
                onCancel={() => setVisible(false)}
                footer={null}
            >
                <Row gutter={[12, 12]}>
                    <Col span={8} ><strong>{t("Para name")}: </strong>&nbsp;{data?.name}</Col>
                    {data?.start_time&&<Col span={8} ><strong>{t("Start time")}: </strong>&nbsp;{data?.start_time}</Col>}
                    {data?.end_time&&<Col span={8} ><strong>{t("End time")}: </strong>&nbsp;{data?.end_time}</Col>}
                    {data?.description&&<Col span={24} ><strong>{t("Description for para")}: </strong>&nbsp;{data?.description}</Col>}
                    <Col className="d-f justify-content-between" span={24}><span><strong>{t("Status")}: </strong><BadgeStatusText status={data?.status} /></span> <Button type="link" onClick={() => setShowCreated(!showCreated)} >details</Button> </Col>
                </Row>
                {data.createdBy && showCreated ? <Row gutter={[12, 12]} className="border py-2 mt-2">
                    <Col span={24} ><Text style={{ fontWeight: 'bold' }}>{t("Created By")}</Text></Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("First Name")}: </Text>{data.createdBy.first_name}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Last Name")}: </Text>{data.createdBy.last_name}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Login")}: </Text>{data.createdBy.username}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Role")}: </Text>{data.createdBy.role}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Created at")}: </Text>{moment(data?.created_at).format('MM-DD-YYYY')}</Col>
                </Row> : null}
                {data.updatedBy && showCreated ? <Row gutter={[12, 12]} className="border py-2 mt-2">
                    <Col span={24} ><Text style={{ fontWeight: 'bold' }}>{t("Updated By")}</Text></Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("First Name")}: </Text>{data.updatedBy.first_name}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Last Name")}: </Text>{data.updatedBy.last_name}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Login")}: </Text>{data.updatedBy.username}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Role")}: </Text>{data.updatedBy.role}</Col>
                    <Col lg={{ span: 12 }} xs={{ span: 24 }}><Text>{t("Updated at")}: </Text>{moment(data?.updated_at).format('MM-DD-YYYY')}</Col>
                </Row> : null}
            </Modal>}
        </>
    )
}


export default ParaView;